import shortid from 'shortid';
import { FS } from '../constants';
import { IEvent } from '../types/Event';
import {
  CollectionListener,
  createSingleCollectionListenerStore,
  useCollectionListener
} from './collectionListener';
import { setDoc, store } from './db';
import { Doc, generateToDocFn } from './document';

const eventCollection = () => store().collection(FS.events);
const eventRsvpCollection = () => store().collection(FS.eventRsvps);

export const toEventDoc = generateToDocFn<IEvent>((d) => d);

const getEventListener = createSingleCollectionListenerStore(
  () => new CollectionListener(eventCollection(), toEventDoc)
);

export const updateEvent = (eventId: string, event: IEvent) => {
  return eventCollection().doc(eventId).set(event);
};

export const createEvent = (event: IEvent) => {
  const doc: Doc<IEvent> = {
    id: shortid(),
    collection: FS.events,
    data: event
  };
  return setDoc(doc);
};

export const useEvents = () => {
  return useCollectionListener(getEventListener());
};
